import { gql } from "@apollo/client";

export const filterCatalogs = gql`
  query FilterCatalogs($filters: CatalogFilters) {
    filterCatalogs(filters: $filters) {
      total
      offset
      limit
      items {
        catalogId
        catalogName
        type
      }
    }
  }
`;

export const listRewards = gql`
  query ListRewards($filter: RewardFilterInput, $page: Int, $size: Int) {
    listRewards(filter: $filter, page: $page, size: $size) {
      first
      last
      self
      total
      items {
        id
        name
        description
        shortDescription
        partnerId
        programId
        quantity
        imageUrl
        catalogId
        rewardUnitId
        rewardTypeName
        rewardTypeId
      }
    }
  }
`;

export const listRewardTypes = gql`
  query ListRewardType($page: Int, $size: Int) {
    listRewardType(page: $page, size: $size) {
      items {
        id
        name
      }
    }
  }
`;
